export const HighFiveThreesomeSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={226} height={200} fill="none">
    <g clipPath="url(#a)">
      <path
        fill="#0038FF"
        d="M150.372 4.52s-37.268-13.883-73.415 7.012C40.804 32.432 22.955 74.6 7.6 108.36c-15.36 33.765-5.848 68.422 22.15 84.529 27.991 16.103 46.606-6.878 85.592-7.514 38.986-.637 49.543 5.164 81.622-16.832 32.084-21.996 37.276-74.832 11.263-114.305C182.209 14.765 150.372 4.52 150.372 4.52Z"
      />
      <path
        fill="#fff"
        d="M150.372 4.52s-37.268-13.883-73.415 7.012C40.804 32.432 22.955 74.6 7.6 108.36c-15.36 33.765-5.848 68.422 22.15 84.529 27.991 16.103 46.606-6.878 85.592-7.514 38.986-.637 49.543 5.164 81.622-16.832 32.084-21.996 37.276-74.832 11.263-114.305C182.209 14.765 150.372 4.52 150.372 4.52Z"
        opacity={0.7}
      />
      <g stroke="#222" strokeMiterlimit={10} opacity={0.3}>
        <path d="M41.614 42.98c6.58-6.58 6.58-17.249 0-23.83-6.58-6.58-17.25-6.58-23.83 0-6.58 6.581-6.58 17.25 0 23.83 6.58 6.58 17.25 6.58 23.83 0Z" />
        <path d="M29.7 46.77c8.672 0 15.702-7.03 15.702-15.703 0-8.673-7.03-15.703-15.703-15.703-8.672 0-15.703 7.03-15.703 15.703 0 8.672 7.03 15.703 15.703 15.703Z" />
        <path d="m32.686 35.781-2.987-4.714H16.825" />
      </g>
      <g stroke="#222" strokeMiterlimit={10} opacity={0.3}>
        <path d="M171.876 14.458h-17.115v34.834h17.115V14.458ZM191.094 14.458H173.98v34.834h17.114V14.458ZM210.313 14.458h-17.115v34.834h17.115V14.458ZM171.876 51.094h-17.115v34.833h17.115V51.094ZM191.094 51.094H173.98v34.833h17.114V51.094ZM210.313 51.094h-17.115v34.833h17.115V51.094ZM171.876 87.73h-17.115v34.833h17.115V87.729ZM191.094 87.73H173.98v34.833h17.114V87.729ZM210.313 87.73h-17.115v34.833h17.115V87.729ZM171.876 124.365h-17.115v34.833h17.115v-34.833ZM191.094 124.365H173.98v34.833h17.114v-34.833ZM210.313 124.365h-17.115v34.833h17.115v-34.833Z" />
      </g>
      <path stroke="#222" strokeMiterlimit={10} d="M8.93 162.821h216.784" />
      <path
        fill="#222"
        d="M22.69 116.219s0-.047.024-.056a.04.04 0 0 1 .051.018c1.212 2.796 2.062 5.732 2.773 8.695a80.81 80.81 0 0 1 1.532 9.015l.219 2.28c.032.381.074.762.102 1.143l.06 1.142c.033.762.08 1.524.102 2.29l-.018 2.29-.023 1.142c-.019.381-.047.762-.07 1.143-.056.761-.102 1.523-.172 2.28-.144 1.519-.376 3.028-.608 4.533 0 .019-.019.033-.042.033a.042.042 0 0 1-.042-.042c0-.766.037-1.523.051-2.285.023-.757.088-1.514.08-2.276 0-.757.018-1.514.022-2.271l.024-1.133-.019-1.134-.01-2.271-.06-2.266-.023-1.133c-.014-.377-.042-.758-.065-1.134l-.14-2.266a80.616 80.616 0 0 0-1.281-8.992c-.604-2.968-1.347-5.922-2.457-8.745h-.01ZM22.366 128.081s.004-.042.023-.052c.023-.009.042 0 .05.024.656 1.885 1.176 3.813 1.617 5.763.423 1.951.752 3.93.952 5.922.2 1.983.423 3.971.45 5.968.033 1.997 0 3.995-.213 5.987 0 .019-.018.033-.037.037a.045.045 0 0 1-.046-.037c-.233-1.988-.372-3.971-.511-5.954-.14-1.983-.158-3.967-.288-5.95a53.744 53.744 0 0 0-.706-5.898c-.335-1.956-.748-3.902-1.296-5.815l.005.005ZM15.789 132.256s.037-.023.056-.014c1.644 1.04 3.116 2.355 4.398 3.836a17.6 17.6 0 0 1 1.719 2.392l.352.669.28.692c.097.228.166.464.24.701.07.237.15.474.214.711.493 1.904.822 3.85.91 5.801.08 1.951.042 3.906-.218 5.843 0 .018-.018.032-.037.032-.023 0-.042-.014-.042-.037l-.501-5.782c-.2-1.914-.32-3.837-.734-5.704-.051-.232-.12-.46-.176-.692-.06-.232-.117-.46-.205-.683l-.237-.668-.302-.632a17.127 17.127 0 0 0-1.574-2.392c-1.175-1.514-2.555-2.898-4.13-4.017 0 0-.022-.038-.008-.056h-.005Z"
      />
      <path
        fill="#222"
        d="M18.975 139.687c.896.581 1.496 1.491 2.002 2.406.478.933.86 1.927 1.12 2.944.078.251.138.507.194.762l.181.771c.093.516.163 1.04.195 1.561.005.524.024 1.049-.014 1.569a13.564 13.564 0 0 1-.204 1.561c0 .014-.014.028-.032.033-.024 0-.042-.01-.047-.033a15.095 15.095 0 0 1-.279-1.537c-.078-.511-.162-1.017-.222-1.524a24.022 24.022 0 0 1-.181-1.514c-.07-.501-.107-1.012-.219-1.509a13.51 13.51 0 0 0-.86-2.917c-.39-.929-.895-1.853-1.68-2.508h-.005s-.019-.042-.01-.056a.045.045 0 0 1 .056-.014l.005.005ZM28.199 145.483c.218-2.568.641-5.109 1.04-7.649.4-2.541.846-5.077 1.31-7.603a319.53 319.53 0 0 1 1.528-7.561c0-.019.023-.033.047-.033.023 0 .037.023.032.047a301.15 301.15 0 0 0-1.212 7.612c-.386 2.54-.748 5.081-1.068 7.626-.316 2.55-.558 5.1-.878 7.645l-.938 7.645s-.019.032-.037.037c-.024 0-.042-.014-.042-.037-.028-.646-.028-1.287-.047-1.932-.004-.646.028-1.287.037-1.932.024-1.292.135-2.574.233-3.86l-.005-.005ZM29.736 145.446a56.2 56.2 0 0 1 .52-3.037l.363-1.5c.116-.502.232-.999.376-1.496a41.862 41.862 0 0 1 1.965-5.838l.306-.706.344-.692c.218-.465.483-.91.729-1.356.539-.873 1.096-1.747 1.853-2.457a.042.042 0 0 1 .056 0c.014.014.019.042 0 .056-.701.729-1.212 1.63-1.695 2.517-.223.455-.46.906-.65 1.375l-.303.696-.269.716a41.653 41.653 0 0 0-1.709 5.842c-.232.99-.39 1.997-.58 2.991l-.242 1.505c-.088.502-.195.999-.265 1.5-.162 1.004-.343 2.007-.52 3.01a57.217 57.217 0 0 1-.553 3.019c0 .018-.018.032-.041.032a.041.041 0 0 1-.042-.041c0-1.027.018-2.053.07-3.08.06-1.026.18-2.043.287-3.065v.009ZM31.863 145.576a44.463 44.463 0 0 1 1.626-3.957c.618-1.286 1.282-2.55 2.044-3.748a.044.044 0 0 1 .055-.014c.019.009.024.037.014.056-.668 1.249-1.235 2.55-1.746 3.869a45.647 45.647 0 0 0-1.384 3.999c-.4 1.351-.688 2.73-1.05 4.091-.376 1.356-.683 2.731-1.1 4.106-.005.019-.02.028-.038.028a.042.042 0 0 1-.041-.042c-.019-1.435.12-2.866.399-4.273.25-1.412.748-2.763 1.221-4.11v-.005ZM31.952 150.063c.241-.846.66-1.63 1.128-2.369.465-.743 1.004-1.449 1.645-2.044.33-.287.673-.561 1.044-.789a4.318 4.318 0 0 1 1.19-.539c.018-.004.037 0 .046.023.01.019 0 .042-.019.051h-.004c-.771.344-1.422.911-1.97 1.533-.557.623-1.003 1.333-1.37 2.076-.39.739-.59 1.551-.929 2.313-.148.39-.297.78-.469 1.171-.148.394-.31.794-.515 1.184 0 0-.019.023-.033.023-.023 0-.042-.018-.042-.037-.018-.441.01-.878.052-1.314.065-.432.153-.86.255-1.287l-.01.005Z"
      />
      <path
        fill="#0038FF"
        d="M31.79 126.343s4.207-.97 5.178-5.503c.97-4.533-2.16-2.592.645-9.712 2.806-7.12 2.16-8.741 1.19-10.789-.971-2.048-1.51-1.403-2.374 1.296-.864 2.698-3.994 6.906-5.179 14.779-1.189 7.877.54 9.925.54 9.925v.004ZM23.485 118.685s2.805-.971 2.912-6.256c.107-5.286-2.048-4.208-2.373-10.789-.326-6.582-.757-11.222-1.942-11.328-1.189-.107-4.314 3.237-5.392 10.575-1.078 7.338 1.403 12.192 3.562 14.352 2.16 2.159 3.238 3.45 3.238 3.45l-.005-.004ZM33.303 132.706s.646-3.882 1.942-5.717c1.296-1.834 4.1-3.451 5.935-7.013s3.883-5.285 3.776-.214c-.107 5.072-2.373 7.659-5.178 9.387-2.806 1.727-6.475 3.562-6.475 3.562v-.005ZM34.488 139.399s2.591-4.965 6.367-8.629c3.776-3.669 6.795-5.504 5.718-3.669-1.078 1.834-2.374 1.727-4.208 4.965-1.835 3.237-1.296 5.61-3.883 7.445-2.592 1.834-3.994-.107-3.994-.107v-.005ZM34.813 145.762c.107-.325.213-2.698 3.883-4.64 3.669-1.941 7.12-1.189 6.688-.213-.432.97-2.699 2.591-4.965 3.562-2.267.971-5.61 1.296-5.61 1.296l.004-.005ZM23.698 132.925s1.617-2.049.758-6.368c-.864-4.315-2.806-3.237-4.965-5.504-2.16-2.266-1.728-2.591-3.883-4.965-2.16-2.373-4.101-3.669-4.965-2.698-.864.971.432 3.994 1.728 5.717 1.295 1.728 3.344 2.592 4.314 4.747.971 2.16.54 5.611 3.02 7.227 2.48 1.616 3.989 1.834 3.989 1.834l.005.01ZM18.306 134.109s-3.883-4.422-6.688-7.659c-2.805-3.237-3.883-5.717-3.99-3.562-.106 2.16-.97 3.883 1.296 6.688 2.267 2.805 9.387 4.533 9.387 4.533h-.005ZM20.355 141.234s.106-1.728-6.043-5.718c-6.15-3.989-8.74-4.746-8.09-3.13.645 1.616 3.343 3.237 6.255 6.149 2.913 2.912 7.878 2.699 7.878 2.699Z"
      />
      <path
        stroke="#222"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M31.534 125.884s1.444-7.738 2.954-13.242c1.51-5.503 2.48-8.847 2.48-8.847M23.731 118.764s-2.624-8.388-3.483-13.46c-.864-5.072.107-8.848.538-11.114M33.642 132.548s1.603-2.861 3.976-5.666 4.208-4.315 5.285-7.013M23.698 132.925s-.863-5.179-2.912-7.877c-2.048-2.699-6.149-6.907-7.77-9.6M35.063 145.646s3.633-2.364 6.22-3.66"
      />
      <path
        fill="#222"
        stroke="#222"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M23.69 174.233a3.237 3.237 0 0 1-3.229-2.964c-.538-6.404-1.662-20.802-1.082-21.513 2.378-2.898 12.62-2.898 14.997 0 .58.711-.543 15.104-1.082 21.513a3.234 3.234 0 0 1-3.228 2.964h-6.381.004ZM83.63 119.479h-2.517v10.069h2.518v-10.069ZM122.491 119.479h-2.517v10.069h2.517v-10.069Z"
      />
      <path
        fill="#D5D8DE"
        stroke="#222"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M86.626 86.587h29.493a3.35 3.35 0 0 1 3.348 3.349v43.945h-36.19V89.936a3.35 3.35 0 0 1 3.35-3.35Z"
      />
      <path
        fill="#fff"
        stroke="#222"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M84.89 174.228a1.886 1.886 0 1 0 0-3.771 1.886 1.886 0 0 0 0 3.771ZM103.295 172.342a1.886 1.886 0 0 0-3.771 0 1.887 1.887 0 0 0 3.771 0ZM119.816 172.342a1.887 1.887 0 0 0-3.772 0c0 1.041.846 1.886 1.886 1.886s1.886-.845 1.886-1.886Z"
      />
      <path
        fill="#222"
        stroke="#222"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M103.114 162.863v-31.109h-3.316v30.909l-.12.084-17.148 6.92v2.048h2.675v-1.416l14.858-2.188.274 3.604h1.983l.274-3.581 14.704 2.165v1.416h2.676v-2.048l-16.86-6.804Z"
      />
      <path
        fill="#222"
        stroke="#222"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M106.635 135.196h-10.53v3.729h10.53v-3.729Z"
      />
      <path
        fill="#D5D8DE"
        stroke="#222"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M121.153 127.082H81.587c-.703 0-1.272.57-1.272 1.272v5.787c0 .703.57 1.273 1.272 1.273h39.566c.703 0 1.273-.57 1.273-1.273v-5.787c0-.702-.57-1.272-1.273-1.272ZM82.26 113.655h-3.083c-.583 0-1.055.472-1.055 1.054v5.601c0 .583.472 1.055 1.055 1.055h3.084c.582 0 1.054-.472 1.054-1.055v-5.601c0-.582-.472-1.054-1.054-1.054ZM123.406 113.655h-3.084c-.582 0-1.054.472-1.054 1.054v5.601c0 .583.472 1.055 1.054 1.055h3.084c.582 0 1.054-.472 1.054-1.055v-5.601c0-.582-.472-1.054-1.054-1.054Z"
      />
      <path
        fill="#fff"
        stroke="#222"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M44.65 125.944h111.699v-10.868h-111.7v10.868Z"
      />
      <path
        fill="#222"
        stroke="#222"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M44.65 117.965h111.699v-2.889h-111.7v2.889Z"
      />
      <path
        fill="#fff"
        stroke="#222"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M155.169 174.232h1.584l.525-59.314h-2.638l.529 59.314ZM44.088 174.232h1.584l.529-59.314h-2.638l.525 59.314Z"
      />
      <path
        fill="#fff"
        stroke="#222"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M42.09 115.944h116.79v-2.452H42.09v2.452Z"
      />
      <path
        fill="#fff"
        stroke="#222"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M86.44 113.636h35.141v-1.449h-35.14v1.449Z"
      />
      <path
        fill="#222"
        stroke="#222"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M113.685 106.999h42.279V78.51h-42.279v28.489Z"
      />
      <path
        fill="#D5D8DE"
        stroke="#222"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M122.816 113.636h17.11v-1.607h-17.11v1.607Z"
      />
      <path
        fill="#D5D8DE"
        stroke="#222"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M129.727 113.636h10.199V95.193h-10.199v18.443Z"
      />
      <path
        stroke="#222"
        strokeMiterlimit={10}
        d="m97.982 16.757 4.765 1.19M105.724 7.227l1.394 3.177M133.921 16.757l-4.765 1.19M126.179 7.227l-1.394 3.177M116.249 3.056v3.971"
      />
      <path
        fill="#fff"
        stroke="#222"
        strokeMiterlimit={10}
        d="m120.457 25.735-.971-6.01s-.488-4.069-.488-5.406c0-1.338-.487-1.459-.668-1.212l-.549.302s-.181-1.58-.668-1.092c-.488.488-.548 1.152-.548 1.152s-.548.97-.79 2.188c-.102.506-.181 1.319-.241 2.108l-.307-.409s-.181-2.001-.241-2.429c-.061-.427-.73.06-.79 1.58-.046 1.184.646 4.221.952 5.494-.162 1.365-.306 3.065-.102 3.855.362 1.398 1.091 2.308 1.337 2.67.247.363 1.7 4.31 1.7 4.31l4.371-1.941-2.002-5.16h.005Z"
      />
      <path
        fill="#fff"
        d="M118.817 23.306s-1.277-2.369-1.519-2.791c-.241-.428-1.699-2.188-2.066-3.159-.363-.97-1.213.363-.85 1.398.362 1.031 1.82 2.917 1.82 2.917s-.487 1.64.181 3.038c.669 1.398 2.002 2.001 2.002 2.001"
      />
      <path
        stroke="#222"
        strokeMiterlimit={10}
        d="M118.817 23.306s-1.277-2.369-1.519-2.791c-.241-.428-1.699-2.188-2.066-3.159-.363-.97-1.213.363-.85 1.398.362 1.031 1.82 2.917 1.82 2.917s-.487 1.64.181 3.038c.669 1.398 2.002 2.001 2.002 2.001M117.781 13.409s-.427 4.737-.241 6.558M116.569 13.469s-.427 3.767-.181 5.346"
      />
      <path
        fill="#0038FF"
        stroke="#222"
        strokeMiterlimit={10}
        d="M152.606 56.88s-7.483-2.605-7.984-2.605c-.502 0-5.741-.376-5.741-.376l-6.195-3.237-9.986-20.273-5.885 2.856s2.1 10.845 3.781 16.813c1.681 5.968 3.599 9.405 3.599 9.405l13.363 9.944.673.924 14.375-13.45ZM131.427 81.427s-2.773 12.103-2.773 18.578c0 6.474.167 8.155.59 8.406.418.251 5.211 1.092 5.634 1.008.422-.084 1.681-.506 1.681-.506s6.135-29.084 6.809-32.697c.673-3.614 1.598-11.514 1.598-11.514s-7.06 6.052-8.997 8.156c-1.937 2.104-1.765 2.187-2.605 3.78-.841 1.593-1.932 4.793-1.932 4.793l-.005-.004Z"
      />
      <path
        fill="#fff"
        stroke="#222"
        strokeMiterlimit={10}
        d="M134.627 173.88s-2.253 3.724-2.647 4.115c-.395.39-3.823 2.452-4.803 2.744-.98.293-2.057.883-2.057 1.863s3.232 1.472 4.9 1.472c1.667 0 6.567-.292 7.152-.292s1.668-.098 2.155 0c.492.097 2.94.492 3.628.195.687-.293 1.272-2.745 1.077-3.823-.195-1.077-.785-3.53-.785-3.53l-8.625-2.744h.005ZM164.616 177.604l-1.667 2.745s-2.192 1.974-3.432 2.745c-3.005 1.877 1.277 2.977 3.232 2.843 1.375-.093 3.92-.098 4.705-.493.785-.39 4.017-2.55 5.295-3.53 1.272-.979 1.37-2.057 1.175-3.33-.195-1.272-1.078-3.232-1.078-3.232s-5.192-1.668-6.665-.492c-1.472 1.175-1.569 2.744-1.569 2.744h.004Z"
      />
      <path
        fill="#222"
        stroke="#222"
        strokeMiterlimit={10}
        d="m135.881 106.075-2.225 11.681s-3.892 24.365-3.78 25.252c.111.891 4.788 26.055 4.9 27.054.111.998-1.004 2.002-1.004 2.002l.223 2.447s2.782 1.89 4.673 2.336c1.89.446 4.783.558 4.783.558s1.004-2.114 1.004-2.448c0-.334-.669-2.559-.669-2.893 0-.335-1.784-29.725-1.784-29.725l4.338-16.799s5.899 17.798 6.451 19.024c.558 1.221 11.286 28.414 11.286 28.414s-1.003 1.333-.668 2.337c.334 1.003.78 2.893.78 2.893s2.448-2.782 3.669-1.89c1.222.892 1.445 1.89 1.445 1.89l3.892-1.556s.334-1.556.111-2.336c-.223-.78-.78.223-.78-2.67 0-2.894-3.832-20.185-4.612-22.851-.78-2.671-4.004-7.678-4.004-7.678l-1.444-26.924v-6.228l-26.59-1.89h.005Z"
      />
      <path
        fill="#fff"
        stroke="#222"
        strokeMiterlimit={10}
        d="M154.589 58.237s-2.87-.91-4.041-.39c-1.17.52-10.798 10.742-10.928 11.393-.13.65-4.905 32.641-5.685 35.107-.78 2.466 3.507 5.588 3.507 5.588l2.596 1.17 2.206-2.596-.13 3.116s6.753.13 8.834-.13c2.076-.26 10.129-2.336 10.129-2.336s1.691-28.057 1.821-28.578c.13-.52 1.43-18.313 1.43-18.313l-2.466-1.56-7.273-2.466v-.005Z"
      />
      <path
        fill="#fff"
        stroke="#222"
        strokeMiterlimit={10}
        d="m154.552 66.002 1.816 3.633s5.276-5.709 5.88-7.093c.603-1.384 1.124-1.472.78-2.336-.344-.864-1.212-1.728-1.212-1.728s-8.045-.26-9.08.26c-1.036.52-3.892 7.004-4.064 7.441l-.172.432 5.448-.952.604.343Z"
      />
      <path
        fill="#0038FF"
        stroke="#222"
        strokeMiterlimit={10}
        d="M152.104 58.985s-17.821 16.557-18.745 17.653c-.924 1.096-1.932 4.793-1.932 4.793s1.598-7.06 2.187-8.155c.59-1.092 13.195-14.036 13.195-14.036l3.363-2.355 3.446.841-1.514 1.259Z"
      />
      <path
        fill="#fff"
        stroke="#222"
        strokeMiterlimit={10}
        d="M154.032 36.682s-3.549 3.72-3.461 4.412c.089.692-.088 1.644-.088 1.644s-3.72 3.029-4.064 3.112c-.343.088-.343.692-.088 1.212.26.52.692.604.864 1.036.172.432.088 1.644-.604 4.064s-1.036 2.768-.344 3.2c.692.432 5.708 2.164 5.708 2.164s.172 7.264.521 8.305c.343 1.035 2.076.171 2.076.171l7.264-6.92V57.87l5.708-6.832s1.556-5.62-.172-8.304c-1.728-2.68-10.812-6.489-11.073-6.572-.26-.088-1.472-.26-2.247.52Z"
      />
      <path
        fill="#222"
        stroke="#222"
        strokeMiterlimit={10}
        d="M160.348 34.522s1.472-.864.52-1.295c-.952-.432-1.988-.089-2.248 0-.26.088.26-2.597-1.212-1.816-1.472.78-3.372 2.68-3.804 3.98-.432 1.3.864 3.804 1.988 3.98 1.124.172 3.632 1.036 3.632 1.036s.692.52.26 1.472c-.432.952-2.94 2.857-2.596 3.372.344.52 1.212 1.728 1.212 1.728s-.864 1.556-.692 1.988c.172.431.692.603.692.603s1.556-.952 2.856-.603c1.301.348.781 2.508.261 3.46-.521.952-1.213 2.076-1.213 2.076s1.473 3.372 1.816 3.372c.344 0 4.584-4.236 6.4-6.14 1.816-1.905 2.597-5.188 2.165-7.956-.432-2.768-5.016-6.489-6.489-7.353-1.472-.863-3.548-1.904-3.548-1.904Z"
      />
      <path
        stroke="#222"
        strokeMiterlimit={10}
        d="M148.152 44.21c-.781-.52-.172-2.94.52-3.2.692-.26 1.816 1.728 1.816 1.728s3.72 2.857 3.804 3.372c.088.52-1.988 2.076-3.112 2.165-1.124.088-1.556.088-1.556-1.556 0-1.644.604-2.768.604-2.768M154.292 46.11l4.672 3.2M152.044 42.738s1.727.172 2.419 1.728M147.98 50.263s1.556.692 3.372 0M160 54.503s-1.816.432-2.68 0"
      />
      <path
        fill="#222"
        stroke="#222"
        strokeMiterlimit={10}
        d="m151.955 57.526 3.289-.172-3.2 3.029-.089-2.857Z"
      />
      <path
        fill="#0038FF"
        stroke="#222"
        strokeMiterlimit={10}
        d="M163.028 60.21s-1.742 2.996-3.437 8.974c-1.695 5.982-3.479 24.1-3.479 26.065 0 1.964 4.552 25.526 4.909 26.417.358.892 2.587.98 2.587.98s6.605-4.463 6.962-5.712c.358-1.25-4.193-22.224-4.193-22.224s8.299-27.133 7.765-27.49c-.534-.358-11.11-7.01-11.11-7.01h-.004Z"
      />
      <path
        stroke="#222"
        strokeMiterlimit={10}
        d="M166.107 63.202s-5.531 22.135-6.874 25.972c-1.337 3.836-3.125 6.07-3.125 6.07"
      />
      <path
        fill="#fff"
        stroke="#222"
        strokeMiterlimit={10}
        d="M164.259 118.824s-.836 1.286-1.287 1.797c-.45.516-1.672 1.092-1.091 1.477.58.386 2.118-.32 2.503-.901l-.13-2.378.005.005Z"
      />
      <path
        fill="#fff"
        stroke="#222"
        strokeMiterlimit={10}
        d="M167.761 113.84s-3.372 3.252-3.563 3.572c-.19.321-.385 3.019-.385 3.79 0 .771.515 1.221.771 1.286.255.066.771.066.771.066l.836-.131s.771-.065 1.542.131c.771.19 2.313.19 2.698-.191.386-.385.771-1.347.771-1.347s.451-.515.576-1.286c.13-.771.901-4.626.901-4.626s-5.462-1.877-4.914-1.259l-.004-.005Z"
      />
      <path
        stroke="#222"
        strokeMiterlimit={10}
        d="m165.35 122.549.581-3.595M167.022 122.358l.641-3.083M168.95 122.484l.576-2.889"
      />
      <path
        fill="#0038FF"
        stroke="#222"
        strokeMiterlimit={10}
        d="M174.137 67.22s9.099 20.124 10.348 23.25c1.25 3.125.27 4.254 0 5.057-.269.804-10.571 20.273-10.571 20.273l-6.158-1.964 6.344-20.413-4.695-8.894 4.732-17.314v.004Z"
      />
      <path
        fill="#fff"
        stroke="#222"
        strokeMiterlimit={10}
        d="M124.734 32.117s.061-2.434.502-3.874c.436-1.435.125-2.062-.186-1.937-.311.126-.687.186-.873 1.31-.186 1.124-.251 1.686-.251 2.373 0 .688.813 2.123.813 2.123l-.005.005Z"
      />
      <path
        fill="#fff"
        stroke="#222"
        strokeMiterlimit={10}
        d="M117.986 25.02c.111-.195.822.571 1.314 1.021-.195-.399-.246-.422-.562-1.11-.376-.812-.306-1.281-.251-1.5.168-.65 1.501.794 1.891 1.547-.2-.604-.609-1.858-.702-2.234-.125-.502-.06-1.184.312-1.435.376-.251.938 1.063.938 1.063s.813.377 1.124.999l2.122 4.245.186 2.996 1.937 7.37 4.496 6.247-4.961 2.41-2.907-6.906s-.748-.622-1.31-1.5c-.409-.636-.785-2.995-1.008-4.904a8.858 8.858 0 0 1-.381-1.459c-.181-1.063-.51-3.553-.51-3.553s-.953-1.138-1.468-1.904c-.302-.455-.404-1.138-.256-1.393h-.004Z"
      />
      <path
        stroke="#222"
        strokeMiterlimit={10}
        d="M120.489 25.308s.855 1.337 1.166 2.094c.255.623.478 1.538.478 1.538M120.926 22.372s1.625 3.809 1.997 4.37c.376.563.562 1.752.562 2.063M119.305 26.041s1.212 1.138 1.361 1.468c.148.33.622 2.127.622 2.127"
      />
      <path
        fill="#fff"
        stroke="#222"
        strokeMiterlimit={10}
        d="M158.648 152.984s.632 8.787-.237 13.06c-.868 4.273-4.036 10.604-4.352 11.477-.315.868-3.009 10.603-2.93 11.003.079.399 1.978 3.799 1.741 5.461-.236 1.663-.631 2.137-1.346 2.295-.711.158-4.115.079-6.41 1.978-2.294 1.9-5.699 1.505-6.888 1.426-1.189-.079-4.272-.079-4.43-.71-.158-.632 1.662-2.058 2.61-2.453.947-.394 3.483-2.531 4.194-3.246.71-.715 3.404-4.194 3.957-5.541.553-1.347 2.136-21.922 2.61-25.089.474-3.168.79-6.726.711-8.704-.079-1.979.394-3.089.394-3.089l10.367 2.137.009-.005Z"
      />
      <path
        fill="#0038FF"
        stroke="#222"
        strokeMiterlimit={10}
        d="M136.41 196.517c.353-.149.92-.534 1.533-.994.664.297 1.593.678 2.03.678.71 0 5.935-3.484 7.756-4.51 1.477-.831 3.572-1.045 4.315-1.091.483 1.151.957 2.512.831 3.39-.237 1.663-.632 2.137-1.347 2.294-.71.158-4.115.079-6.409 1.979-2.295 1.9-5.699 1.505-6.888 1.426-1.189-.079-4.273-.079-4.431-.711-.158-.631 1.663-2.057 2.61-2.452v-.009Z"
      />
      <path
        fill="#fff"
        stroke="#222"
        strokeMiterlimit={10}
        d="M184.555 150.653s2.791 4.839 3.999 9.581c1.207 4.747 1.022 25.029 1.207 25.401.186.371 1.863 4.282 2.699 5.954.836 1.677 2.884 4.185 2.884 4.932 0 .748-1.491.743-1.769.743h-5.119s-1.393-.464-1.676-1.021c-.279-.558-.465-2.977-1.115-3.721-.65-.743-2.234-2.698-2.327-3.72-.093-1.022.557-4.184.557-4.932 0-.748-2.048-9.024-2.698-11.165-.65-2.142-3.906-7.724-4.282-12.373-.376-4.649-.743-6.698-.743-6.698l8.374-2.977.009-.004Z"
      />
      <path
        fill="#0038FF"
        stroke="#222"
        strokeMiterlimit={10}
        d="M187.778 184.622c1.055.307 1.979 1.426 2.499 2.155.608 1.384 1.602 3.641 2.188 4.812.836 1.676 2.884 4.184 2.884 4.932 0 .748-1.491.743-1.77.743h-5.118s-1.393-.464-1.677-1.021c-.278-.558-.464-2.978-1.114-3.721-.651-.743-2.234-2.698-2.327-3.72-.056-.608.153-1.969.33-3.13.288-.288 1.848-1.705 4.101-1.045l.004-.005Z"
      />
      <path
        fill="#222"
        stroke="#222"
        strokeMiterlimit={10}
        d="M193.584 197.264h-5.118s-1.394-.464-1.677-1.021c-.279-.558-.464-2.978-1.115-3.721-.548-.627-1.755-2.108-2.178-3.176l.251-.265s2.503-2.016 4.338-.915c1.834 1.101 2.322 3.664 3.483 4.946 1.161 1.282 3.107 2.234 3.785 3.409 0 .743-1.491.743-1.769.743Z"
      />
      <path
        fill="#0038FF"
        stroke="#222"
        strokeMiterlimit={10}
        d="M186.311 75.728s2.898 15.866 2.986 16.386c.088.52 2.434 8.262 2.09 10.004-.348 1.742-7.571 16.441-7.571 16.441s-1.825-3.046-2.09-3.218c-.264-.172.697-14.7.697-14.7l-2.87-9.308s-.019-9.488 1.221-11.304c1.24-1.816 5.04-5.207 5.537-4.296v-.005Z"
      />
      <path
        stroke="#222"
        strokeMiterlimit={10}
        d="M180.472 93.312s4.115-1.054 6.41-3.349M182.386 96.563s3.158 2.011 6.409 2.011"
      />
      <path
        fill="#fff"
        stroke="#222"
        strokeMiterlimit={10}
        d="M187.188 111.583a735.42 735.42 0 0 1-3.372 6.976s-1.825-3.047-2.09-3.218c-.097-.065-.027-2.044.098-4.529 2.104 1.445 4.013 1.268 5.364.771Z"
      />
      <path
        fill="#222"
        stroke="#222"
        strokeMiterlimit={10}
        d="M178.87 102.903s4.059 10.459 5.639 14.551c1.583 4.092 1.815 25.939 1.815 25.939l-.464 8.188s-9.117 4.283-19.539 3.814c-10.422-.465-19.354-3.442-19.354-3.442s.047-18.959 2.374-25.284c2.326-6.326 3.998-12.749 3.998-12.749l.781-9.805 24.75-1.208v-.004Z"
      />
      <path
        fill="#0038FF"
        d="M183.993 80.85c-.167.414-4.185 13.526-4.185 13.526s-.956 3.13-1.045 3.478c-.088.349.172 4.436.26 4.784.089.348.725-.581.465.641-.26 1.217-1.393 1.305-2.09 1.653-.697.349-6.001 2.262-11.57 2.174-5.568-.088-11.829-1.217-11.829-1.217s-.957-1.741-1.129-2.522c-.171-.785.316-2.554.316-2.554l-2.336-18.722s-9.684-12.8-11.007-13.71c-1.324-.91-3.056-2.23-3.553-2.643-.497-.414-.994-1.24-1.324-2.15-.33-.91-9.14-16.948-9.14-16.948s2.229-2.397 2.81-2.564c.58-.167 1.899-.33 1.899-.33l11.453 12.814s2.23 1.073 2.727 1.324c.497.246.413 1.653.413 1.653l3.483 1.56 11.691 3.693 5.582 1.347s15.787 5.95 16.776 6.447c.994.497 3.72 2.313 3.637 3.14-.084.826-1.57 4.212-1.57 4.212"
      />
      <path
        stroke="#222"
        strokeMiterlimit={10}
        d="M183.993 80.85c-.167.414-4.185 13.526-4.185 13.526s-.956 3.13-1.045 3.478c-.088.349.172 4.436.26 4.784.089.348.725-.581.465.641-.26 1.217-1.393 1.305-2.09 1.653-.697.349-6.001 2.262-11.57 2.174-5.568-.088-11.829-1.217-11.829-1.217s-.957-1.741-1.129-2.522c-.171-.785.316-2.554.316-2.554l-2.336-18.722s-9.684-12.8-11.007-13.71c-1.324-.91-3.056-2.23-3.553-2.643-.497-.414-.994-1.24-1.324-2.15-.33-.91-9.14-16.948-9.14-16.948s2.229-2.397 2.81-2.564c.58-.167 1.899-.33 1.899-.33l11.453 12.814s2.23 1.073 2.727 1.324c.497.246.413 1.653.413 1.653l3.483 1.56 11.691 3.693 5.582 1.347s15.787 5.95 16.776 6.447c.994.497 3.72 2.313 3.637 3.14-.084.826-1.57 4.212-1.57 4.212"
      />
      <path
        stroke="#222"
        strokeMiterlimit={10}
        d="M160.023 92.476c2.545 3.404 5.945 7.515 8.824 9.47M156.238 87.07s1.203 1.867 2.991 4.329M172.047 101.217c.451.311.901.594 1.329.817M166.065 95.857s2.476 2.685 5.049 4.673M143.075 59.955s-3.804 4.38-3.72 3.056c.084-1.323-.33-1.323.91-2.312"
      />
      <path
        fill="#fff"
        stroke="#222"
        strokeMiterlimit={10}
        d="M165.545 42.882s-4.64 2.764-5.034 3.65c-.395.888-.59 3.062-1.087 3.554-.493.492-3.354 1.184-3.256 1.876.097.692 1.184 2.764 1.184 2.764s-.195 6.613-.195 7.106c0 .492.59.79 1.185.887.589.097 1.973.492 1.973.492v1.58s3.851 1.281 4.246 1.281c.394 0 2.958.195 2.958.195s5.23-3.455 6.906-8.388c1.677-4.932 0-8.782-1.876-11.053-1.876-2.272-7.009-3.948-7.009-3.948l.005.004Z"
      />
      <path
        fill="#222"
        stroke="#222"
        strokeMiterlimit={10}
        d="M166.335 56.207s3.255-2.666 4.045-.492c.79 2.169.098 3.353-.887 3.748s-3.353 1.184-3.353 1.184-2.271 5.23-2.467 7.404c-.195 2.173-1.579 3.85-.887 5.327.692 1.481 1.677 2.071 6.512 2.564 4.835.492 10.343-.219 13.799-1.7 3.455-1.482 2.977-6.693 2.289-7.877-.692-1.184-3.947-5.327-3.85-7.501.098-2.169 3.061-5.513.957-11.528-1.858-5.313-10.929-8.606-13.395-8.308-2.466.297-4.64 0-4.64 1.579s.098 3.158 1.775 5.327c1.676 2.169.692 3.85.297 4.245-.395.395-1.677 1.676-1.482 3.256.195 1.579 1.282 2.763 1.282 2.763l.005.01Z"
      />
      <path
        stroke="#222"
        strokeMiterlimit={10}
        d="M160.631 56.792s-.343 1.482-2.624 1.027M162.113 48.925s-.228-1.082-1.37-1.082"
      />
      <path
        fill="#222"
        d="M160.153 50.197c-.223.45-.269.883-.102.971.167.084.487-.214.715-.664.228-.45.269-.883.102-.97-.167-.09-.487.213-.715.663Z"
      />
      <path
        fill="#fff"
        stroke="#222"
        strokeMiterlimit={10}
        d="M65.898 45.6s.256-.512-.51-1.282c-.767-.771-4.185-2.903-5.212-3.586-1.026-.683-2.22-2.82-6.32-.344-4.102 2.476-6.833 6.92-7.349 10.079-.51 3.158 1.538 7.004 5.383 9.14 3.846 2.136 6.832 2.476 6.832 2.476l.428.77 12.126-1.792s1.965-2.048 1.71-3.247c-.256-1.198-2.392-5.21-2.392-5.21s1.365-2.049.938-2.648c-.427-.6-5.638-4.357-5.638-4.357h.004Z"
      />
      <path
        fill="#222"
        stroke="#222"
        strokeMiterlimit={10}
        d="M60.859 55.933s-1.71.6-2.392.855c-.683.255-2.647-.344-3.502-2.048-.855-1.705.427-3.502 1.366-3.674.938-.172 1.709.427 2.22.344.51-.084.51-.683.599-1.194.083-.511-1.366-1.454-1.366-1.454s1.965-2.136 2.476-3.074c.51-.939-3.502-1.881-3.674-2.648-.172-.766 3.586-2.308 3.586-2.308-1.027-.683-2.22-2.82-6.322-.344-4.1 2.476-6.832 6.92-7.347 10.079-.511 3.158 1.537 7.004 5.383 9.14 2.517 1.398 4.663 2.025 5.847 2.294l.901-.501s.428-.511 1.454-2.048c1.026-1.538.77-3.419.77-3.419Z"
      />
      <path
        stroke="#222"
        strokeMiterlimit={10}
        d="M65.304 45.256s-1.11-.172-1.965 1.365M70.598 54.308s-1.62.682-3.757-1.194"
      />
      <path
        fill="#222"
        d="M65.759 47.759c.297.59.334 1.17.079 1.3-.251.126-.697-.246-.994-.835-.297-.59-.334-1.17-.08-1.301.252-.125.698.246.995.836Z"
      />
      <path
        fill="#0038FF"
        stroke="#222"
        strokeMiterlimit={10}
        d="M69.488 61.827s-10.162-.855-10.76.256c-.6 1.11-.512 3.33-.512 3.33l11.189-2.564.083-1.027v.005Z"
      />
      <path
        fill="#fff"
        stroke="#222"
        strokeMiterlimit={10}
        d="M86.027 57.025s20.775-22.67 20.9-23c.126-.33.753-7.654.818-8.16.06-.51-.102-1.3.511-2.09.613-.785 1.779-2.624 1.779-2.624s.924-1.95 1.23-2.346c.307-.394 1.069-.989 1.561-1.532.497-.544 1.235-.971 1.63-.664.395.306.581 1.588.581 1.588s.52.01.678.803c.162.795-1.115 4.942-1.166 5.365-.051.423-.437 4.333-.896 6.688-.456 2.355-1.171 3.99-1.877 4.849s-8.225 11.825-10.115 13.92c-1.89 2.094-9.359 15.103-9.359 15.103l-6.27-7.9h-.005Z"
      />
      <path
        stroke="#222"
        strokeMiterlimit={10}
        d="M109.524 22.089s-1.036 2.898-1.083 3.293c-.046.395-.311 2.582-.311 2.582M111.781 18.41s-1.342 3.749-1.491 4.334a19.804 19.804 0 0 0-.288 1.375M115.032 18.202s-.404 1.323-1.008 2.66c-.604 1.339-1.147 3.814-1.161 3.93M113.666 16.827s-1.574 4.003-1.797 4.862c-.223.86-.525 2.355-.632 2.546"
      />
      <path
        fill="#222"
        stroke="#222"
        strokeMiterlimit={10}
        d="m80.528 71.107 12.642 34.838-2.842 3.98-2.986-5.583-2.35-11.899-4.464-21.336Z"
      />
      <path
        fill="#fff"
        stroke="#222"
        strokeMiterlimit={10}
        d="M53.26 96.805s-1.253 5.016-.385 5.694c.868.673 8.783 3.088 8.973 2.8.195-.288.098-3.474-.097-4.342-.195-.869-1.64-2.025-1.64-2.025l-6.85-2.123v-.004Z"
      />
      <path
        fill="#0038FF"
        stroke="#222"
        strokeMiterlimit={10}
        d="M55.476 82.235s-2.508 12.74-2.318 13.223c.195.483 6.66 1.254 6.66 1.254l-4.342-14.477Z"
      />
      <path
        fill="#0038FF"
        stroke="#222"
        strokeMiterlimit={10}
        d="M52.68 93.043s-.771 4.054.195 4.537c.966.483 6.753 2.025 7.236 1.352.483-.674-.195-3.572-.195-3.572s-6.753-3.088-7.236-2.317Z"
      />
      <path
        fill="#fff"
        stroke="#222"
        strokeMiterlimit={10}
        d="M79.562 188.194s3.145 2.354 4.04 2.582c.897.223 4.041 1.235 4.376 1.797.334.562 0 2.355-.45 3.029-.451.673-6.847 1.681-9.875 1.347-3.028-.335-9.65 1.235-10.324-.897-.674-2.132.45-5.276.45-5.276s9.763-2.132 11.783-2.582Z"
      />
      <path
        fill="#fff"
        stroke="#222"
        strokeMiterlimit={10}
        d="M85.623 195.04c-1.235.334-6.172.562-12.006.785-3.715.144-5.606-.576-6.493-1.12.014.465.08.924.21 1.347.673 2.132 7.296.562 10.324.896 3.028.335 9.428-.673 9.874-1.346.177-.27.34-.716.446-1.189-.794.209-1.742.459-2.355.627ZM38.38 181.459s-2.694 5.611-2.244 6.846c.45 1.236 1.798 1.459 3.029 1.909 1.23.451 4.375.334 5.276.896.9.562 5.16 2.471 7.18 2.806 2.02.334 4.152-.562 4.375-1.459.223-.896-3.256-3.59-4.603-4.486-1.346-.897-3.478-4.041-3.478-4.041l-9.54-2.471h.005Z"
      />
      <path
        fill="#fff"
        stroke="#222"
        strokeMiterlimit={10}
        d="M42.866 189.652c-2.498-.599-5.968-2.085-6.697-2.406-.093.46-.116.832-.033 1.059.45 1.236 1.798 1.459 3.029 1.909 1.235.451 4.375.334 5.276.896.9.562 5.16 2.471 7.18 2.806 2.02.334 4.152-.562 4.375-1.459.047-.176-.06-.432-.265-.724-.938.566-2.215 1.221-3.214 1.282-1.797.111-6.846-2.694-9.65-3.368v.005Z"
      />
      <path
        fill="#222"
        stroke="#222"
        strokeMiterlimit={10}
        d="M60.603 110.338s-2.475 9.522-2.587 12.215c-.111 2.694.112 5.388.112 5.388s-1.797 1.347-1.458 2.471c.334 1.124.896 1.909.896 1.909s-4.264 16.269-4.826 17.059c-.562.789-6.507 9.985-8.081 13.13-1.57 3.144-5.276 16.26-5.276 16.26s-.785.785-.897 1.57c-.111.785-.334 2.132-.334 2.132s1.236 2.471 4.603 2.916c3.367.451 5.16-.223 5.16-.223s.562-.784.785-1.908c.223-1.124.562-2.917.562-2.917l6.284-10.887 10.436-19.177 3.144-8.978s1.458 13.242 1.347 13.804c-.111.562-3.028 10.65-3.028 15.587 0 4.937.334 15.261.334 15.261s-.896 1.57-.673 2.471l.223.897.45 1.458s4.375-.111 6.396-.451c2.02-.334 5.387-2.131 5.387-2.131s.335-1.57 0-2.132c-.334-.562-.785-1.124-.896-1.681-.112-.562-.45-1.909-.112-3.479.335-1.57 3.813-25.127 5.16-31.072 1.347-5.949 1.682-25.135 1.57-28.614-.111-3.479-.562-5.95-.562-5.95l.223-4.04s-6.284-2.694-11.671-3.029c-5.388-.334-11.895.674-11.895.674l-.78 1.472.004-.005Z"
      />
      <path
        stroke="#BABDD5"
        strokeMiterlimit={10}
        d="m62.73 128.503 4.153 6.735 1.793 5.271M70.422 128.327a50.105 50.105 0 0 0 1.844-1.728c.562-.562 1.347-8.305 1.458-8.639M62.169 118.963s0 5.834.673 7.069c.674 1.236 5.049 3.929 5.722 3.702"
      />
      <path
        stroke="#222"
        strokeMiterlimit={10}
        d="M63.404 116.386s6.061-1.008 9.986.334"
      />
      <path
        stroke="#BABDD5"
        strokeMiterlimit={10}
        d="M78.396 146.198c.149 3.293.284 7.929-.07 9.127-.561 1.909-.896 2.243-1.235 3.144-.334.897.112 1.909-.111 2.471s-.897 10.427-1.459 13.005c-.561 2.582-.673 8.192-.673 8.192M80.347 112.907s-.785 9.874-1.124 13.018c-.334 3.145-1.458 7.966-1.347 9.986.112 2.02.335 6.846.335 6.846s.028.432.065 1.142"
      />
      <path
        stroke="#222"
        strokeMiterlimit={10}
        d="M75.076 183.591v2.582s.896.223.673 1.124c-.223.897-1.008 1.57-1.008 1.57"
      />
      <path
        fill="#0038FF"
        stroke="#222"
        strokeMiterlimit={10}
        d="M58.212 65.413s-3.674 4.012-4.612 8.624c-.939 4.612 2.22 10.85 2.22 10.85l5.294 19.558s-1.537 1.193-1.62 2.22c-.084 1.026.343 3.418 1.11 3.673.77.256 12.725.172 12.725.172s11.872 2.137 12.127 2.137c.255 0 1.62-1.194 1.62-2.564s-.255-3.33-.343-4.185c-.088-.854-3.502-23.315-3.845-24.852-.344-1.538-.465-7.612-.465-7.612l7.153-5.31 1.221-1.574-5.471-8.833s-8.764 2.14-9.191 2.485c-.428.343-17.937 5.21-17.937 5.21h.014Z"
      />
      <path
        fill="#0038FF"
        stroke="#222"
        strokeMiterlimit={10}
        d="M83.32 58.766s5.782 10.506 6.13 10.464c.349-.041 3.563-2.41 3.79-2.898.232-.487-.153-1.565-.153-1.565s-6.015-7.868-6.558-8.365c-.543-.497-1.166-.31-1.38.005-.213.316-2.224.59-1.834 2.36h.005Z"
      />
      <path
        stroke="#222"
        strokeMiterlimit={10}
        d="M82.432 73.434 71.183 81.83M69.27 94.45c-.58 1.008-1.18 1.941-1.797 2.75M75.057 80.86s-1.37 5.202-5.03 12.21M70.984 94.863s-4.157 6.233-6.103 7.919"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M.286 0h225.428v200H.286z" />
      </clipPath>
    </defs>
  </svg>
)
export default HighFiveThreesomeSvg
